import styled, { CSSProperties } from 'styled-components';

import { NorlysColor, NorlysFont } from '~src/branding';

import { Icon } from './Icon';

export type ChevronProps = { open?: boolean; style?: CSSProperties; onClick?: () => void };

export const Chevron = ({ open, style, onClick }: ChevronProps) => {
  const props = { style: { cursor: onClick ? 'pointer' : 'default', ...style }, onClick };

  return (
    <div {...{ ...props, style: { width: 'fit-content', height: 'fit-content' } }}>
      <Icon.Chevron {...props} direction={open ? 'up' : 'down'} />
    </div>
  );
};

const dimensions = { width: '20px', height: '20px' };

const Circle = styled.div({
  ...dimensions,
  backgroundColor: NorlysColor.secondary.darkGreen,
  fontWeight: 600,
  borderRadius: '20px',
  position: 'relative',
});

const Label = styled.div({
  ...dimensions,
  position: 'absolute',
  left: 0,
  top: 0,
  ...NorlysFont.style('default', 20),
  lineHeight: '22px',
  color: 'white',
  transition: 'transform .5s, width .2s, height .2s',
  textAlign: 'center',
  userSelect: 'none',
  fontWeight: 'lighter',
});

export const CrossChevron = ({ open, style, onClick }: ChevronProps) => {
  return (
    <Circle style={{ ...style, cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
      <Label
        style={{
          transform: open ? 'rotate(45deg)' : undefined,
          width: open ? '19px' : undefined,
          height: open ? undefined : '21px',
        }}
      >
        +
      </Label>
    </Circle>
  );
};
